export default {
  meta: {
    title: '开店区域'
  }
};
